import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://192.168.0.226/api/v1";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

/* ─── Request Interceptor ────────────────────────────────────────────────── */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    // Use api.defaults.headers.common — the Axios-official way to inject a
    // header into EVERY request method (GET, POST, PUT, PATCH, DELETE).
    // Setting it only on config.headers can fail for DELETE+custom-headers in
    // Axios 1.x because the per-request config may not merge correctly with the
    // instance defaults, causing the Bearer token to be stripped.
    if (token) {
      config.headers = config.headers || {};
      config.headers["Authorization"] = `Bearer ${token}`;
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      if (config.headers) {
        delete config.headers["Authorization"];
      }
      delete api.defaults.headers.common["Authorization"];
    }

    // When sending FormData (file uploads), let the browser set the
    // multipart/form-data boundary automatically by removing Content-Type.
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ─── Response Interceptor — Auto Refresh on 401 ────────────────────────── */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};
    const isAuthEndpoint =
      originalRequest.url?.includes("auth/login") ||
      originalRequest.url?.includes("auth/token/refresh") ||
      originalRequest.url?.includes("auth/token");

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isAuthEndpoint
    ) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const response = await axios.post(
          `${API_BASE_URL}auth/token/refresh/`,
          { refresh: refreshToken }
        );
        const newAccessToken =
          response.data.data?.access || response.data.access;
        const newRefreshToken =
          response.data.data?.refresh || response.data.refresh;

        localStorage.setItem("accessToken", newAccessToken);
        if (newRefreshToken)
          localStorage.setItem("refreshToken", newRefreshToken);

        // Update the instance default so the retried request also has the token
        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${newAccessToken}`;

        return api(originalRequest);
      } catch {
        localStorage.clear();
        delete api.defaults.headers.common["Authorization"];
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
